import addUrlParams from "./addUrlParams";
import getUmbracoEndPoint from "app/umbraco/helpers/UmbracoEndPoint";

export default (request: string, params?: { [name: string]: string }): URL => {
    let baseURL: string;
    let url: URL;

    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
        // baseURL = "https:https://localhost:44392///backend.danishbakery.com/";
        // baseURL = "https://localhost:44392/";
        baseURL =  window.location.origin + "/"; 
    } else {
        baseURL = getUmbracoEndPoint() + "/";
    }

    if (request && typeof request === "string" && request.startsWith("http")) {
        url = new URL(request);
    } else {
        url = new URL(request, baseURL);
    }

    if (params) {
        url = addUrlParams(url, params);
    }

    return url;
};
